import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/app/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_shcookieconsent_2956b7a7 from 'nuxt_plugin_shcookieconsent_2956b7a7' // Source: ./sh-cookie-consent.js (mode: 'all')
import nuxt_plugin_pluginrouting_3eeae668 from 'nuxt_plugin_pluginrouting_3eeae668' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_271a7223 from 'nuxt_plugin_pluginmain_271a7223' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_nuxtenv_1c16254a from 'nuxt_plugin_nuxtenv_1c16254a' // Source: ./nuxt-env.js (mode: 'all')
import nuxt_plugin_libplugin144bbe2e_aaf001d2 from 'nuxt_plugin_libplugin144bbe2e_aaf001d2' // Source: ./lib.plugin.144bbe2e.js (mode: 'all')
import nuxt_plugin_nuxtoauthplugin_c5dd8a08 from 'nuxt_plugin_nuxtoauthplugin_c5dd8a08' // Source: ./nuxt-oauth.plugin.js (mode: 'all')
import nuxt_plugin_raygun_53cbc26f from 'nuxt_plugin_raygun_53cbc26f' // Source: ../src/app/plugins/raygun.client (mode: 'client')
import nuxt_plugin_raygun_6ebafde7 from 'nuxt_plugin_raygun_6ebafde7' // Source: ../src/app/plugins/raygun.server (mode: 'server')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../src/app/plugins/axios (mode: 'all')
import nuxt_plugin_api_caeae0b4 from 'nuxt_plugin_api_caeae0b4' // Source: ../src/app/plugins/api (mode: 'all')
import nuxt_plugin_jss_caea9c54 from 'nuxt_plugin_jss_caea9c54' // Source: ../src/app/plugins/jss (mode: 'all')
import nuxt_plugin_vuemergeoptions_578d24ee from 'nuxt_plugin_vuemergeoptions_578d24ee' // Source: ../src/app/plugins/vue-merge-options (mode: 'all')
import nuxt_plugin_polyfills_a2ea40e0 from 'nuxt_plugin_polyfills_a2ea40e0' // Source: ../src/app/plugins/polyfills (mode: 'client')
import nuxt_plugin_axe_caeadecc from 'nuxt_plugin_axe_caeadecc' // Source: ../src/app/plugins/axe (mode: 'all')
import nuxt_plugin_directives_7e8ad6f8 from 'nuxt_plugin_directives_7e8ad6f8' // Source: ../src/app/plugins/directives (mode: 'all')
import nuxt_plugin_gtm_caeab2a8 from 'nuxt_plugin_gtm_caeab2a8' // Source: ../src/app/plugins/gtm (mode: 'all')
import nuxt_plugin_nuxtclientinit_fd601808 from 'nuxt_plugin_nuxtclientinit_fd601808' // Source: ../src/app/plugins/nuxt-client-init (mode: 'all')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../src/app/plugins/vee-validate (mode: 'all')
import nuxt_plugin_vueclipboard_914d1eca from 'nuxt_plugin_vueclipboard_914d1eca' // Source: ../src/app/plugins/vue-clipboard (mode: 'all')
import nuxt_plugin_clickjacking_72f5b22c from 'nuxt_plugin_clickjacking_72f5b22c' // Source: ../src/app/plugins/click-jacking (mode: 'client')
import nuxt_plugin_globalapi_3de83de4 from 'nuxt_plugin_globalapi_3de83de4' // Source: ../src/app/plugins/global-api (mode: 'all')
import nuxt_plugin_importdecorators_2927ef4c from 'nuxt_plugin_importdecorators_2927ef4c' // Source: ../src/app/plugins/import-decorators (mode: 'all')
import nuxt_plugin_vuelazyload_e6901296 from 'nuxt_plugin_vuelazyload_e6901296' // Source: ../src/app/plugins/vue-lazyload (mode: 'all')
import nuxt_plugin_designsystem_c3f840ac from 'nuxt_plugin_designsystem_c3f840ac' // Source: ../src/app/plugins/design-system (mode: 'all')
import nuxt_plugin_globalcomponents_54ec6fe8 from 'nuxt_plugin_globalcomponents_54ec6fe8' // Source: ../src/app/plugins/global-components (mode: 'all')
import nuxt_plugin_modernizr_2916226e from 'nuxt_plugin_modernizr_2916226e' // Source: ../src/app/plugins/modernizr (mode: 'client')
import nuxt_plugin_urls_925ef650 from 'nuxt_plugin_urls_925ef650' // Source: ../src/app/plugins/urls (mode: 'all')
import nuxt_plugin_vueyoutube_fcf88930 from 'nuxt_plugin_vueyoutube_fcf88930' // Source: ../src/app/plugins/vue-youtube (mode: 'all')
import nuxt_plugin_i18n_926bd3dc from 'nuxt_plugin_i18n_926bd3dc' // Source: ../src/app/plugins/i18n (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"bodyAttrs":{"class":""},"title":"Soho House","titleTemplate":"%s","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"apple-itunes-app","content":"app-id=670256744"}],"link":[{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon-152.png","sizes":"152x152"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon-180.png","sizes":"180x180"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-16.png","sizes":"16x16"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-32.png","sizes":"32x32"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-57.png","sizes":"57x57"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-76.png","sizes":"76x76"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-96.png","sizes":"96x96"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-120.png","sizes":"120x120"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-128.png","sizes":"128x128"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-144.png","sizes":"144x144"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-152.png","sizes":"152x152"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-180.png","sizes":"180x180"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-192.png","sizes":"192x192"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-228.png","sizes":"228x228"},{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Ffavicon.svg"},{"rel":"mask-icon","href":"\u002Ffavicon.svg","color":"#171C26"},{"rel":"manifest","href":"\u002Fmanifest.json"},{"rel":"stylesheet","href":"https:\u002F\u002Fd34if7rq73m6wx.cloudfront.net\u002Fkings-caslon\u002Ffontkit.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_shcookieconsent_2956b7a7 === 'function') {
    await nuxt_plugin_shcookieconsent_2956b7a7(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_3eeae668 === 'function') {
    await nuxt_plugin_pluginrouting_3eeae668(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_271a7223 === 'function') {
    await nuxt_plugin_pluginmain_271a7223(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtenv_1c16254a === 'function') {
    await nuxt_plugin_nuxtenv_1c16254a(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin144bbe2e_aaf001d2 === 'function') {
    await nuxt_plugin_libplugin144bbe2e_aaf001d2(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtoauthplugin_c5dd8a08 === 'function') {
    await nuxt_plugin_nuxtoauthplugin_c5dd8a08(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_raygun_53cbc26f === 'function') {
    await nuxt_plugin_raygun_53cbc26f(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_raygun_6ebafde7 === 'function') {
    await nuxt_plugin_raygun_6ebafde7(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_api_caeae0b4 === 'function') {
    await nuxt_plugin_api_caeae0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_jss_caea9c54 === 'function') {
    await nuxt_plugin_jss_caea9c54(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemergeoptions_578d24ee === 'function') {
    await nuxt_plugin_vuemergeoptions_578d24ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfills_a2ea40e0 === 'function') {
    await nuxt_plugin_polyfills_a2ea40e0(app.context, inject)
  }

  if (typeof nuxt_plugin_axe_caeadecc === 'function') {
    await nuxt_plugin_axe_caeadecc(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_7e8ad6f8 === 'function') {
    await nuxt_plugin_directives_7e8ad6f8(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_caeab2a8 === 'function') {
    await nuxt_plugin_gtm_caeab2a8(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtclientinit_fd601808 === 'function') {
    await nuxt_plugin_nuxtclientinit_fd601808(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (typeof nuxt_plugin_vueclipboard_914d1eca === 'function') {
    await nuxt_plugin_vueclipboard_914d1eca(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickjacking_72f5b22c === 'function') {
    await nuxt_plugin_clickjacking_72f5b22c(app.context, inject)
  }

  if (typeof nuxt_plugin_globalapi_3de83de4 === 'function') {
    await nuxt_plugin_globalapi_3de83de4(app.context, inject)
  }

  if (typeof nuxt_plugin_importdecorators_2927ef4c === 'function') {
    await nuxt_plugin_importdecorators_2927ef4c(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelazyload_e6901296 === 'function') {
    await nuxt_plugin_vuelazyload_e6901296(app.context, inject)
  }

  if (typeof nuxt_plugin_designsystem_c3f840ac === 'function') {
    await nuxt_plugin_designsystem_c3f840ac(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_54ec6fe8 === 'function') {
    await nuxt_plugin_globalcomponents_54ec6fe8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_modernizr_2916226e === 'function') {
    await nuxt_plugin_modernizr_2916226e(app.context, inject)
  }

  if (typeof nuxt_plugin_urls_925ef650 === 'function') {
    await nuxt_plugin_urls_925ef650(app.context, inject)
  }

  if (typeof nuxt_plugin_vueyoutube_fcf88930 === 'function') {
    await nuxt_plugin_vueyoutube_fcf88930(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_926bd3dc === 'function') {
    await nuxt_plugin_i18n_926bd3dc(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
